module.exports = __webpack_public_path__ + "img/df_header.6404f271.png";